// Le menu est caché par utilisateur (cf. loadMenu() dans main.js) : un nouveau login doit le reconstruire.
try {
    Object.keys(sessionStorage)
        .filter((key) => key.startsWith('mainMenu_'))
        .forEach((key) => sessionStorage.removeItem(key));
} catch (e) {
    console.error('Purge du cache menu impossible', e);
}
